import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { Modal, Nav, Tab } from "react-bootstrap";
import "./Ensuring_results.css";

import Use_Reference_Material from "./use_Reference_Material/Use_Reference_Material";
import Replicate_Testing from "./replicate_Testing/Replicate_Testing";
import Use_Alternative_Instrument from "./use_Alternative_Instrument/Use_Alternative_Instrument";
import Retesting_Testing from "./retesting_Testing/Retesting_Testing";
import Blind_Sample from "./blind_Sample/Blind_Sample";
import ILC from "./ilc/ILC";
import PT from "./pt/PT";

import {
  GetAll,
  Delete,
} from "../../../../../../../src/features/admin/quality_management/process_requirement/validity/Slice";
import { useDispatch, useSelector } from "react-redux";
import Success_Toster from "../../../../../../common/common_modal/success_toster/Success_Toster";

const VALIDITY_TYPE_MAP = {
  Use_Reference_Material: 1,
  Use_Alternative_Instrument: 2,
  Replicate_Testing: 3,
  Retesting_Testing: 4,
  Blind_Sample: 5,
  ILC: 6,
  PT: 7,
};

const Ensuring_results = () => {
  const dispatch = useDispatch();
  const validitydetails = useSelector((state) => state.validity);

  const [currentPage, setCurrentPage] = useState(1);
  const [activeValidityTypeId, setActiveValidityTypeId] = useState(1);

  const fetchRecords = async (
    page = 1,
    validityTypeId = activeValidityTypeId,
  ) => {
    await dispatch(
      GetAll({
        page,
        per_page: validitydetails.per_page,
        validity_type_id: validityTypeId,
      }),
    );
  };

  // Initial load
  useEffect(() => {
    fetchRecords(currentPage);
  }, [activeValidityTypeId, currentPage]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [success, setSuccess] = useState(false);
  const confirmDelete = async () => {
    if (!deleteId) return;

    try {
      await dispatch(Delete(deleteId));
      setSuccess(true);
      fetchRecords();
      // fetch(onPageChange); // refresh table
    } catch (error) {
      console.error(error);
    } finally {
      closeDeleteModal();
    }
  };

  const closeDeleteModal = () => {
    setDeleteId(null);
    setShowDeleteModal(false);
  };

  const openDeleteModal = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);
  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Ensuring The Validity Of Results" />
      </div>

      <div className="tables_tab_section">
        <Tab.Container
          defaultActiveKey="Use_Reference_Material"
          onSelect={(key) => {
            const validityTypeId = VALIDITY_TYPE_MAP[key];
            setActiveValidityTypeId(validityTypeId);
            setCurrentPage(1);
            fetchRecords(1, validityTypeId);
          }}
        >
          <Nav variant="pills">
            <Nav.Item>
              <Nav.Link eventKey="Use_Reference_Material">
                Use Of Reference Material
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="Use_Alternative_Instrument">
                Use Of Alternative Instrument
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="Replicate_Testing">
                Replicate Testing
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="Retesting_Testing">
                Retesting Testing
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="Blind_Sample">Blind Sample</Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="ILC">Inter laboratory Comparison</Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="PT">Proficiency Testing</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content className="inner-tab-sec">
            <Tab.Pane eventKey="Use_Reference_Material">
              <Use_Reference_Material
                openDeleteModal={openDeleteModal}
                validitydetails={validitydetails}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="Use_Alternative_Instrument">
              <Use_Alternative_Instrument
                openDeleteModal={openDeleteModal}
                validitydetails={validitydetails}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="Replicate_Testing">
              <Replicate_Testing
                openDeleteModal={openDeleteModal}
                validitydetails={validitydetails}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="Retesting_Testing">
              <Retesting_Testing
                openDeleteModal={openDeleteModal}
                validitydetails={validitydetails}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="Blind_Sample">
              <Blind_Sample
                openDeleteModal={openDeleteModal}
                validitydetails={validitydetails}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="ILC">
              <ILC
                openDeleteModal={openDeleteModal}
                validitydetails={validitydetails}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="PT">
              <PT
                openDeleteModal={openDeleteModal}
                validitydetails={validitydetails}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>

        <Modal show={showDeleteModal} onHide={closeDeleteModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>

          <Modal.Body>Are you sure you want to delete this data?</Modal.Body>

          <Modal.Footer>
            <button className="btn btn-secondary" onClick={closeDeleteModal}>
              No
            </button>

            <button className="btn btn-danger" onClick={confirmDelete}>
              Yes, Delete
            </button>
          </Modal.Footer>
        </Modal>
        {success && <Success_Toster successText="Data Delete successfully!" />}
      </div>
    </section>
  );
};

export default Ensuring_results;
